import type { IDealer } from '@/types/dealer/dealer';

export const DEALER_DATA: IDealer[] = [
  {
    uid: 'dealer_id_1',
    dealer_id: '1',
    mirai: {
      name_km: 'សាខាភ្នំពេញ (ការិយាល័យកណ្តាល)',
    },
    sale: {
      email: '',
    },
  },
  {
    uid: 'dealer_id_2',
    dealer_id: '2',
    mirai: {
      name_km: 'សាខាខេត្តបាត់ដំបង',
    },
    sale: {
      email: '',
    },
  },
  {
    uid: 'dealer_id_3',
    dealer_id: '3',
    mirai: {
      name_km: 'សាខាខេត្តកំពង់ចាម',
    },
    sale: {
      email: '',
    },
  },
];
